import { render, staticRenderFns } from "./reserve-items.vue?vue&type=template&id=a33a651e&scoped=true&"
import script from "./reserve-items.vue?vue&type=script&lang=js&"
export * from "./reserve-items.vue?vue&type=script&lang=js&"
import style0 from "./reserve-items.vue?vue&type=style&index=0&id=a33a651e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33a651e",
  null
  
)

export default component.exports